<template>
    <div class="section-heading" :class="color">
        <line-svg :color="`${color}-stroke`"></line-svg>
        <h3 class="h3">{{ text }}</h3>
    </div>
</template>

<script>
    import LineSvg from '../svgs/LineSvg'

    export default {
        name: "SectionHeading",
        components: { LineSvg },
        props: {
            text: String,
            color: {
                type: String,
                default: 'blue'
            }
        }
    }
</script>

<style lang="scss" scoped>

    .section-heading {
        display: flex;
        align-items: center;
    }

    .h3 {
        margin-left: 20px;
    }

    .blue {
        color: $color1;
    }

    .white {
        color: $white;
    }

</style>